<app-project-auto-complete-input [model]="model"></app-project-auto-complete-input>
<kit-bs-button [kitModel]="confirmProjectAction"></kit-bs-button>
